<template>
  <!--兑换记录--->
  <div class="record">
      <comHead :headObj="headObj"></comHead>
      <div class="record-list">
          <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          >
          <div class="record-list-ul">
              <van-cell v-for="(item,index) in list" :key="index">
                  <div class="record-list-ul-li">
                      <div class="record-list-li-right">
                        <div class="record-name">{{item.reason}}</div>
                        <div class="record-time">
                          <span>兑换时间: {{item.created_at}}</span>
                        </div>
                      </div>
                      <div class="record-list-li-left">
                        {{item.ore_count_change}}
                      </div>
                  </div>
              </van-cell>
          </div>
          </van-list>
      </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { List } from 'vant'
import comHead from './../../components/header.vue'
import { get } from './../../utils/httpService'
Vue.use(List)
export default {
  name: 'record',
  data () {
    return {
      headObj: {
        backgroundc: '#fff',
        color: '#222',
        title: '兑换记录'
      },
      list: [],
      pages: {
        page: 1,
        page_size: 5,
        total: 0
      },
      loading: false,
      finished: false
    }
  },
  components: {
    comHead
  },
  created () {
  //  this.onLoad()
  },
  methods: {
    onLoad () {
      this.fetchData()
    },
    async fetchData () {
      try {
        let templist = await get('/api/user/score/record', {page: this.pages.page, page_size: this.pages.page_size})
        this.pages.page++
        this.list = this.list.concat(templist.score_records)
        console.log(this.list)
        if (this.list.length >= templist.total_records) {
          this.finished = true
        }
        this.loading = false
        console.log('Fetched data:', this.list)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
  }
}
</script>

<style>
.record-list{background: #f8f8f8;width: 100%;height: calc(100vh - 0.9rem);}
.record-list-ul{padding-top:0.1rem}
.record-list .van-list .van-cell{background: #f8f8f8;padding: 0.08rem 0.16rem;}
.record-list .van-list .van-cell__value{background: #fff;}
.record-list-ul-li{padding: 0.1rem 0.15rem;display: flex;justify-content: space-between;align-items: center;}
.record-name{font-size: 18px;}
.record-time{font-size: 14px;color: #888;}
.record-time span:nth-child(1){margin-right: 0.2rem;display: inline-block;min-width: 2.3rem;}
.record-list-li-left{margin-left:0.5rem ;font-size: 0.4rem;color:rgba(238, 183, 2, 0.668);}
/* .record-list-ul-li{border-bottom: 1px solid #eee;} */
</style>



// WEBPACK FOOTER //
// src/view/record/index.vue